import Vue from 'vue';
import Vuex from 'vuex';
import VueAxios from 'vue-axios';
import axios from 'axios';
import { VueAuthenticate } from 'vue-authenticate';

Vue.use(VueAxios, axios);
Vue.use(Vuex);

export default new VueAuthenticate(axios, {
    loginUrl: process.env.API_URL + '/auth/login'
});


// WEBPACK FOOTER //
// ./src/services/auth.js